<template>
    <div class="reservation-filter">
        <reservations-filter-form :prefill="filter" @filter-change="filterChanged"></reservations-filter-form>
    </div>
</template>

<script>
    import ReservationsFilterForm from 'components/forms/reservations/ReservationsFilterForm'

    export default {
        components: { ReservationsFilterForm },

        props: {
            filter: { type: Object, required: true },
            showFilterList: { type: Array, default: () => [] },
        },

        methods: {
            filterChanged(payload) {
                this.emitEvent({ name: 'filter-change', payload })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/reservations/_reservation-fillter.scss';
</style>
